export const images = [
    { id:1, original: '/images/services/1/sub-categories/5/c1-s5-p1.jpg'},
]
